module.exports = __webpack_public_path__ + "img/jobs.bb4e8e99.jpg";